import common from './common'
import auth from './auth'
import company from './company'
import security from './security'
import onboarding from './onboarding'
import htmlViewer from './htmlViewer'
import filemanager from './filemanager'
import profile from './profile'
import menu from './menu'
import userAdmin from './userAdmin'

const modules = [common, auth, company, security, onboarding, htmlViewer, filemanager, profile, menu, userAdmin]

export default modules.reduce((acc, mod) => {
    for (const lang of Object.keys(mod)) {
        acc[lang] = { ...acc[lang], ...mod[lang] }
    }
    return acc
}, {})
